import { journeyStateApi } from './journey-state.api';
import {
  getTokenFromStorage,
  setTokenToStorage,
} from '../../components/persist-token/persist-token.utils';

const actionPrefix = (actionType) => `JourneyState/${actionType}`;

export const SET_SEARCH_QUERY = actionPrefix('SET_SEARCH_QUERY');
const setSearchQuery = (searchQuery) => ({ type: SET_SEARCH_QUERY, payload: searchQuery });

export const SET_PATCH_TEST_PASSED = actionPrefix('SET_PATCH_TEST_PASSED');
const setPatchTestPassed = (patchTestPassed) => ({
  type: SET_PATCH_TEST_PASSED,
  payload: patchTestPassed,
});

export const SET_CATEGORY = actionPrefix('SET_CATEGORY');
const setCategory = (id) => ({ type: SET_CATEGORY, payload: id });

export const SET_JOURNEY_DATA = actionPrefix('SET_JOURNEY_DATA');
const setJourneyState = (data) => ({ type: SET_JOURNEY_DATA, payload: data });

const restoreSelectedData = (token) => (dispatch) =>
  journeyStateApi
    .getDecodedJourneyState(token)
    .then((decodedToken) => {
      dispatch(setJourneyState(decodedToken));
    })
    .then(
      () => Promise.resolve(),
      (e) => e,
    );

const saveJourneyState = () => (dispatch, getState) => {
  const { journeyState } = getState();

  return journeyStateApi
    .updateJourneyState({ ...journeyState, token: getTokenFromStorage() })
    .then(({ token }) => {
      setTokenToStorage(token);
    })
    .then(
      () => Promise.resolve(),
      (e) => e,
    );
};

export const SELECT_FACET = actionPrefix('SELECT_FACET');
const selectFacet = (...facets) => ({
  type: SELECT_FACET,
  payload: facets,
});
export const REMOVE_FACET = actionPrefix('REMOVE_FACET');
const removeFacet = (facet) => ({
  type: REMOVE_FACET,
  payload: facet,
});
export const CLEAR_SELECTED_FACETS = actionPrefix('CLEAR_SELECTED_FACETS');
const clearSelectedFacets = () => ({
  type: CLEAR_SELECTED_FACETS,
});

export const SET_PREV_PATH_CONFIGS = actionPrefix('SET_PREV_PATH_CONFIGS');
const setPrevPathConfigs = (payload) => ({
  type: SET_PREV_PATH_CONFIGS,
  payload,
});

export const journeyStateActions = {
  setJourneyState,
  setSearchQuery,
  setPatchTestPassed,
  setCategory,
  setPrevPathConfigs,

  restoreSelectedData,
  saveJourneyState,

  selectFacet,
  removeFacet,
  clearSelectedFacets,
};
